import React from 'react'
import { AUTH_PREFIX_PATH } from 'constants/route.constant'
import { ADMIN, USER } from 'constants/roles.constant'

const authDemoRoute = [
    {
        key: 'authentication.signInSimple',
        // path: `${AUTH_PREFIX_PATH}/sign-in-simple`,
        path: `${AUTH_PREFIX_PATH}/:lang/sign-in-simple`, // Add the language parameter
        component: React.lazy(() =>
            import('views/auth-demo/SignIn/SignInSimple')
        ),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },

    {
        key: 'authentication.signUpSimple',
        // path: `${AUTH_PREFIX_PATH}/sign-up-simple`,
        path: `${AUTH_PREFIX_PATH}/:lang/sign-up-simple`,
        component: React.lazy(() =>
            import('views/auth-demo/SignUp/SignUpSimple')
        ),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },

    {
        key: 'authentication.forgotPasswordSimple',
        path: `${AUTH_PREFIX_PATH}/:lang/forgot-password-simple`,
        component: React.lazy(() =>
            import('views/auth-demo/ForgotPassword/ForgotPasswordSimple')
        ),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },

    {
        key: 'authentication.resetPasswordSimple',
        path: `${AUTH_PREFIX_PATH}/:lang/reset-password-simple`,
        component: React.lazy(() =>
            import('views/auth-demo/ResetPassword/ResetPasswordSimple')
        ),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },

    {
        key: 'authentication.googleAuth',
        path: `${AUTH_PREFIX_PATH}/google-auth`,
        component: React.lazy(() => import('views/auth/GoogleAuth/GoogleAuth')),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
    {
        key: 'publisher',
        path: `/auth/publisher`,
        component: React.lazy(() => import('views/auth/Publisher')),
        authority: [ADMIN, USER],
        // meta: {
        //     layout: 'blank',
        //     pageContainerType: 'gutterless',
        //     footer: false,
        // },
        meta: {
            layout: 'simple',
            pageContainerType: 'contained',
            footer: true,
        },
    },
   
]

export default authDemoRoute
